import { useQueryClient } from 'react-query'
import { MdOutlineLogout } from 'react-icons/md'
import { Avatar, Dropdown, DropdownContent, Flex, Typography, useDisclosure } from '@nilohealth/core-ui'

import { useCurrentProfessional } from '@professionals/professionals.hooks'
import { useAuth, useNiloId, useSignOut } from '@auth/auth.hooks'

import { NavbarIconWrapper, NavbarMenuItem, NavbarMenuTrigger } from './navbar.styles'

const NavbarProfileMenu = () => {
  const { setIsSignOut } = useAuth()
  const { isOpen, setIsOpen } = useDisclosure()
  const { logout: logoutNiloId } = useNiloId()
  const signOut = useSignOut({ onSuccess: () => logoutNiloId(), })
  const queryCache = useQueryClient()
  const professional = useCurrentProfessional()

  const handleSignOut = () => {
    setIsSignOut(true)
    queryCache.clear()
    signOut.mutate()
  }

  const navbarProfileMenuItems = [
    {
      Icon: MdOutlineLogout,
      name: 'Sair',
      onClick: handleSignOut,
    },
  ]

  return (
    <Flex>
      <Dropdown open={isOpen} onOpenChange={setIsOpen}>
        <NavbarMenuTrigger active={isOpen}>
          <Avatar
            type="professional"
            src={professional?.avatar}
            fallback={professional?.name ?? '?'}
            size="xxsmall"
          />
        </NavbarMenuTrigger>

        <DropdownContent align="center" sideOffset={16} loop asChild>
          <Flex direction="column" gap="nano">
            {navbarProfileMenuItems.map(item => (
              <NavbarMenuItem key={item.name} onSelect={item.onClick}>
                <Flex align="start" gap="nano" css={{ padding: '$nano $xxxsmall' }}>
                  <NavbarIconWrapper primary>
                    <item.Icon />
                  </NavbarIconWrapper>

                  <Typography type="paragraphXSmall" weight="semibold" color="neutralLowDark">
                    {item.name}
                  </Typography>
                </Flex>
              </NavbarMenuItem>
            ))}
          </Flex>
        </DropdownContent>
      </Dropdown>
    </Flex>
  )
}

export default NavbarProfileMenu
